import BaseTemplate from '../src/layouts/BaseTemplate'
import ContactView from '../src/view/_public/ContactView';

export default function Contact() {
  return (
    <BaseTemplate title="Contact" body={<ContactView />} />
  )
}
